import React from 'react'
import ProjectsList from "../assets/content/ProjectsList"

function Projects() {
  const displayProjects = ProjectsList.map((project) => (
    <article
      key={project.uid}
      className="rounded-2xl overflow-hidden border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow"
    >
      {/* Project screenshot */}
      <div className="h-64 overflow-hidden">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Project info */}
      <div className="p-4 border-t border-gray-100">
        <div className="flex items-start justify-between">
          <h3 className="text-[1rem] font-bold text-title">{project.title}</h3>
          <a
            href={project.url}
            target="_blank"
            rel="noreferrer"
            className="text-subtle hover:text-title transition-colors ml-2 shrink-0 mt-0.5"
          >
            <i className="ri-arrow-right-up-line text-xl"></i>
          </a>
        </div>
        <p className="text-[0.813rem] text-muted mt-1">{project.subtitle}</p>
      </div>
    </article>
  ))

  return (
    <div className="pb-10">
      {/* Section header */}
      <div className="flex items-center justify-between mb-6">
        <p className="text-sm font-bold tracking-widest text-title">PROJECTS</p>
        <a
          href="https://github.com/hhphu"
          target="_blank"
          rel="noreferrer"
          className="text-muted text-[0.813rem] flex items-center gap-1 hover:text-title transition-colors"
        >
          View all <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>

      {/* Projects grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {displayProjects}
      </div>
    </div>
  )
}

export default Projects
